/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Download/view.blocks to change it.
import CardBase from 'DesignSystem/CardBase/index'
import DownloadCSV from './DownloadCSV/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Download({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Download"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Download.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={0}
 text="Download"
/>
<CardBase
  viewPath={`${viewPath}/CardBase`}
 marginTop={16}
 alignSelf="stretch"
 backgroundColor="#fff"
 shadowColor="rgba(0, 0, 0, 0)"
 zIndex={100}
>
{childProps => (
<div
  data-testid="Download.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<DownloadCSV
  viewPath={`${viewPath}/DownloadCSV`}
/>
</div>
)}
</CardBase>
</div>
{children}
</React.Fragment>)
}